import { render, staticRenderFns } from "./Retailer.vue?vue&type=template&id=628a4a76"
import script from "./Retailer.vue?vue&type=script&lang=js"
export * from "./Retailer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports